/**
 * UX mirror of functions/sms/accessControl.js.
 * Backend SMS_ALLOWED_USER_IDS remains the source of truth for authorization.
 */
export const SMS_ALLOWED_USER_IDS = [
  'kIAz8XBuTQdRoOFHfKFcgTNeE6O2', // Дмитро
  '26cky9lbSieNNuHaKJqGTvnNeY83', // Іванка
  '1uBaPmet8DQUlylFHTRnW35ypPQ2', // Галя
]

export const SMS_AUTHOR_LABELS = {
  kIAz8XBuTQdRoOFHfKFcgTNeE6O2: 'Дмитро',
  '26cky9lbSieNNuHaKJqGTvnNeY83': 'Іванка',
  '1uBaPmet8DQUlylFHTRnW35ypPQ2': 'Галя',
}

export const isSmsAllowedUser = (uid) => Boolean(uid && SMS_ALLOWED_USER_IDS.includes(uid))

export const formatSmsAuthorName = (uid, createdByLabel) => {
  if (createdByLabel) return createdByLabel
  if (!uid) return 'Гість'
  return SMS_AUTHOR_LABELS[uid] || '—'
}
